/* global mixpanel */
import _ from 'lodash'

export function libraryModifierStart ({current_outlet}) {
  mixpanel.track('Library Modifier Start', {
    'Current Selected Outlet': current_outlet
  })
}

export function libraryModifierChangeOutlet ({prevOutlet, currOutlet}) {
  mixpanel.track('Library Modifier Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet
  })
}

export function libraryModifierCreate ({modifier, allOutlet}) {
  const eventName = (allOutlet) ? 'Library Modifier Create All Outlet' : 'Library Modifier Create One Outlet'
  mixpanel.track(eventName, {
    'Name': modifier.name,
    'Options': modifier.options
  })
}

export function libraryModifierUpdateOneOutlet ({prevName, prevOptions, newName, newOptions}) {
  mixpanel.track('Library Modifier Update One Outlet', {
    'Old Name': prevName,
    'Old Options': prevOptions,
    'New Name': newName,
    'New Options': newOptions
  })
}

export function libraryModifierApplyToItems ({name, options, itemNames}) {
  mixpanel.track('Library Modifier Apply To Items', {
    'Name': name,
    'Options': options,
    'Item Names': itemNames
  })
}

export function libraryModifierDelete ({name, options}) {
  mixpanel.track('Library Modifier Delete', {
    'Name': name,
    'Options': _.map(options, 'id')
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/modifier.js